import Vue from "vue";
import Vuex from "vuex";
import process from "process";

Vue.use(Vuex);

import authentication from "./auth";
import download from "./download";
import playlists from "./playlists";
import playlistItems from "./playlistItems";
import songs from "./songs";
import teamSongs from "./teamSongs";
import tags from "./modules/tags";
import playlistTemplates from "./modules/playlistTemplates";

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  modules: {
    authentication,
    download,
    playlists,
    playlistItems,
    songs,
    teamSongs,
    tags,
    playlistTemplates
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js